import { useState } from 'react';
import { useAuth } from '../auth';
import { useI18n } from '../i18n';
import { api } from '../api';

export function UserMenu() {
  const { user, signOut } = useAuth();
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  if (!user) return null;

  const isYandex = user.provider === 'yandex';
  const label = isYandex ? user.name ?? user.email ?? t('auth.menu.account') : t('auth.menu.anon');
  const source = isYandex ? user.name ?? user.email ?? 'Y' : 'G';
  const initials = source
    .split(/\s+/)
    .map((p: string) => p[0] ?? '')
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="user-menu">
      <button
        className="user-menu-trigger"
        onClick={() => setOpen((o) => !o)}
        type="button"
      >
        {isYandex && user.avatarUrl ? (
          <img className="user-avatar" src={user.avatarUrl} alt="" />
        ) : (
          <div className="user-avatar user-avatar-fallback">{isYandex ? initials : '◐'}</div>
        )}
        <div className="user-menu-label">
          <div className="user-menu-name">{label}</div>
          {isYandex && user.email && <div className="user-menu-sub">{user.email}</div>}
        </div>
      </button>
      {open && (
        <div className="user-menu-pop" onMouseLeave={() => setOpen(false)}>
          {!isYandex && (
            <a className="user-menu-item primary" href={api.yandexSignInUrl()}>
              {t('auth.signin')}
            </a>
          )}
          {isYandex && (
            <button
              className="user-menu-item"
              type="button"
              onClick={() => {
                setOpen(false);
                void signOut();
              }}
            >
              {t('auth.signout')}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
